import React,{ useState, useEffect }  from "react";
import styles from './Event.module.css'


export default function Event({ event, boolean }) {

    const[dayName, setDayName] = useState('');
    const[dateNumber, setDateNumber] = useState('');
    const[eventTime, setEventTime] = useState('');
    

    useEffect(() => {
      getDate(event)
    }, [event])

    const getDate = (event) => {
      let startDate = '';
      let endDate = '';
      let startTime = '';
      let endTime = '';

      //sets the start date
      if (event.start.date) {
        startDate = event.start.date;
        setEventTime('Hele dagen')
      } else if (event.start.dateTime) {
        startDate = event.start.dateTime.split("T")[0]; // Extract date part
        var setupStartTime = event.start.dateTime.split("T")[1]; //Extract time part
        startTime = setupStartTime.split(":")[0] + ":" + setupStartTime.split(":")[1];
      } else {
        setDayName("No date given");
      }

      //sets the end dat
      if (event.end.date) {
        endDate = event.end.date;
      } else if (event.end.dateTime) {
        endDate = event.end.dateTime.split("T")[0]; // Extract date part
        var setupEndTime = event.end.dateTime.split("T")[1]; //Extract time part
        endTime = setupEndTime.split(":")[0] + ":" + setupEndTime.split(":")[1];
      } else {
        setDayName("No date given");
      }
      //If the event runs over more than one date, the start and end date are not the same
      if(startDate !== endDate){
        const startDay = new Date(startDate);
        const startDayDate = startDate.split('-')[2];
        const options = { weekday: 'long' };
        const startDayName = startDay.toLocaleString('da-DK', options);
        const endDay = new Date(endDate);
        const endDayDate = endDate.split('-')[2];
        const endDayName = endDay.toLocaleString('da-DK', options);
        if(startTime === ''){ //Take into account if no time is given
          setEventTime("Se begivenheden for programoversigt")
        } else {
          setEventTime( "Starter " + startDayName + " kl. " + startTime + " og slutter " + endDayName + " kl. " + endTime)
        }
        setDayName( startDayName + " - " + endDayName );
        setDateNumber( startDayDate + ". - " + endDayDate + ".");

      } else {
          const day = new Date(startDate);
          const dayDate = startDate.split('-')[2];
          const options = { weekday: 'long' };
          const name = day.toLocaleString('da-DK', options);
          setEventTime("Kl. " + startTime + " - " + endTime)
          setDayName(name);
          setDateNumber( dayDate +".")
      }

    }


  
    // Render the event div conditionally
    return boolean ? 
      <div className={styles.eventWrapper}>
        <div className={styles.dateWrapper}>
          <h3 className={styles.dayName}>{dayName}</h3>
          <h2 className={styles.dateNumber} >{dateNumber}</h2>
        </div>
        <div className={styles.pillar}/>
        <div className={styles.eventInfoWrapper}>
          <h3 className={styles.eventTitle}>{event.summary}</h3>
          <h4 className={styles.eventTime}>{eventTime}</h4>
          <h4 className={styles.location}>{event.location}</h4>
          <p className={styles.description} dangerouslySetInnerHTML={{ __html: event.description }}></p>
        </div>
      </div>
      

      : 
      null;
  }